module.exports = __webpack_public_path__ + "static/media/09.d4e3767d.png";